"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _Interaction = _interopRequireWildcard(require("./Interaction.js"));

var _KeyCode = _interopRequireDefault(require("../events/KeyCode.js"));

var _condition = require("../events/condition.js");

var _coordinate = require("../coordinate.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/KeyboardPan
 */


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */

/**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */
var KeyboardPan =
/** @class */
function (_super) {
  __extends(KeyboardPan, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function KeyboardPan(opt_options) {
    var _this = _super.call(this) || this;

    var options = opt_options || {};
    /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */

    _this.defaultCondition_ = function (mapBrowserEvent) {
      return (0, _condition.noModifierKeys)(mapBrowserEvent) && (0, _condition.targetNotEditable)(mapBrowserEvent);
    };
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */


    _this.condition_ = options.condition !== undefined ? options.condition : _this.defaultCondition_;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 100;
    /**
     * @private
     * @type {number}
     */

    _this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    return _this;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @this {KeyboardPan}
   */


  KeyboardPan.prototype.handleEvent = function (mapBrowserEvent) {
    var stopEvent = false;

    if (mapBrowserEvent.type == _EventType["default"].KEYDOWN) {
      var keyEvent =
      /** @type {KeyboardEvent} */
      mapBrowserEvent.originalEvent;
      var keyCode = keyEvent.keyCode;

      if (this.condition_(mapBrowserEvent) && (keyCode == _KeyCode["default"].DOWN || keyCode == _KeyCode["default"].LEFT || keyCode == _KeyCode["default"].RIGHT || keyCode == _KeyCode["default"].UP)) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
        var deltaX = 0,
            deltaY = 0;

        if (keyCode == _KeyCode["default"].DOWN) {
          deltaY = -mapUnitsDelta;
        } else if (keyCode == _KeyCode["default"].LEFT) {
          deltaX = -mapUnitsDelta;
        } else if (keyCode == _KeyCode["default"].RIGHT) {
          deltaX = mapUnitsDelta;
        } else {
          deltaY = mapUnitsDelta;
        }

        var delta = [deltaX, deltaY];
        (0, _coordinate.rotate)(delta, view.getRotation());
        (0, _Interaction.pan)(view, delta, this.duration_);
        keyEvent.preventDefault();
        stopEvent = true;
      }
    }

    return !stopEvent;
  };

  return KeyboardPan;
}(_Interaction["default"]);

var _default = KeyboardPan;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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